import { stripHtml } from './Messages';
export const getCopyButtonText = response => {
  let message = '';

  // Guard against null/undefined response
  if (!response) {
    return '';
  }

  // Handle SimplifiedPreviewResult type
  if ('llmResponse' in response && 'createdAt' in response) {
    const simplifiedResult = response;
    message = simplifiedResult.llmResponse && simplifiedResult.llmResponse[0] && 'text' in simplifiedResult.llmResponse[0] && simplifiedResult.llmResponse[0].text || '';
  }
  // Handle ActionResponse and Message types
  else if ('sections' in response) {
    message = response.sections && response.sections[0] && 'text' in response.sections[0] && response.sections[0].text || '';
  }
  return stripHtml(message);
};